<template>
  <div class="clazz_show_header bgwhite">
    <div class="info">
      <div class="clazz_name">{{ clazz.clazz_name }}</div>
      <div class="time_range">
        {{ clazz.start_time_format2 }} ~
        {{ clazz.end_time_format2 }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClazzShowHeader',
  components: {
  },
  props: {
    clazz: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.clazz_show_header {
  height: 130px;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .info {
    font-size: 32px;
    margin-left: 20px;
    .time_range {
      margin-top: 6px;
      font-size: 24px;
      color: #969696;
    }
  }
}
</style>
